import React, { Component } from 'react';

class HelpContent extends Component {
    render() {        
        return (
            <div>
                <p>
                    For additional support, please contact a member of our <br/>
                    Retirement Specialist Team at <a href="tel:+18003456488">800-345-6488</a> or email us at 
                    &nbsp;<a href="mailto:ipro@americancentury.com">ipro@americancentury.com</a>.
                </p>            
            </div>
        );
    }
}

export default HelpContent;